module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/firehose-2015-08-04.paginators.json
// module id = 1258
// module chunks = 0